import React from 'react';
import PropTypes from 'prop-types';
import { localsMessages } from '../../utility/getTemplateData';
import { Button } from '@paypalcorp/pp-react';
const messages = localsMessages('common/oneTouch');

class OneTouchNextButton extends React.Component {
  render() {
    const buttonnext = messages.button && messages.button.next;

    return (
      <Button
        className="btn-wide"
        id="payWithPP"
        disabled={this.props.disabled}
        onClick={this.props.handleNext}
      >
        {buttonnext}
      </Button>
    );
  }
}

OneTouchNextButton.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  handleNext: PropTypes.func,
};

export default OneTouchNextButton;
